import React from "react";
import {Route, Switch} from "react-router-dom";
import Screen from "@components/Screen";
import DataScreens from "../DataScreens";
import AddScreen from "./Add";
import EditScreen from "./Edit";
import ViewScreen from "./View";
import StudentSessions from "@screens/Admin/Students/Sessions";
import StudentCps from "@screens/Admin/Students/CPs";
import StudentLanguages from "@screens/Admin/Students/Languages";


export default ({match}) => {
  const {path} = match;
  return (
    <Screen>
      <Switch>
        <Route path={path} exact component={DataScreens.Students}/>
        <Route path={`${path}/add`} exact component={AddScreen}/>
        <Route path={`${path}/:id`} exact component={ViewScreen}/>
        <Route path={`${path}/:id/edit`} exact component={EditScreen}/>
        <Route path={`${path}/:id/sessions`} exact component={StudentSessions}/>
        <Route path={`${path}/:id/cps`} exact component={StudentCps}/>
        <Route path={`${path}/:id/languages`} exact component={StudentLanguages}/>
      </Switch>
    </Screen>
  );
}
